/**
 * Где запущена программа: приложение Android, приложение iPhone или браузер.
 *
 * `isNativeApp()` отвечает «приложение или браузер», и для большинства
 * экранов этого хватает: одна сборка, одна база на устройстве, один
 * адрес сервера. Различается немногое, и всё оно — про систему телефона:
 * APK обновляют файлом с сервера, а iPhone — из App Store (правило 103);
 * навигатор открывает `geo:` на Android и ссылка Яндекс Карт на iPhone;
 * запрет передачи данных лежит в разных местах настроек.
 *
 * Сборка без `getPlatform` (старый Capacitor, тесты) — это Android: до
 * приложения для iPhone другого и не было.
 */
export type NativePlatform = 'android' | 'ios';

export function nativePlatform(): NativePlatform | null {
  const capacitor = (
    globalThis as { Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string } }
  ).Capacitor;
  if (capacitor?.isNativePlatform?.() !== true) return null;
  return capacitor.getPlatform?.() === 'ios' ? 'ios' : 'android';
}

/**
 * Куда идти, когда сервер молчит при живом интернете: приложению могли
 * запретить передачу данных в настройках телефона (правило 233).
 */
export function dataPermissionHint(): string {
  return nativePlatform() === 'ios'
    ? 'в Настройках iPhone откройте «БлагоДар» и включите «Сотовые данные»'
    : 'в настройках телефона: Приложения → БлагоДар → Передача данных (Сетевой доступ): ' +
        'разрешите мобильные данные и Wi‑Fi';
}
